'use strict';

var flatten = function flatten(array) {
  return array.reduce(function (acc, val) {
    return acc.concat(val);
  }, []);
};

module.exports.flatten = flatten;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/utils/flatten.js
// module id = 203
// module chunks = 0